import React, { Component, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { axiosInstance } from '@appblocks/frontend/client/utils';
import { Link, NavLink, useHistory } from 'react-router-dom';
import ReactJson from 'react-json-view';
import Spinner from 'react-bootstrap/Spinner';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import Tooltip from 'react-bootstrap/Tooltip';
import {
    FaExternalLinkAlt, FaExclamationTriangle,
} from 'react-icons/fa';
import { IoRadioOutline } from 'react-icons/io5';
import { confirm as confirmDialog } from 'react-bootstrap-confirmation';
import { BsThreeDotsVertical } from 'react-icons/bs';
import CloudDeviceDashboard from '@appblocks/frontend/client/Components/DeviceDashboard/CloudDeviceDashboard';
import MetricsView from '@appblocks/frontend/cloudclient/Components/MetricsView';
import EventsView from '@appblocks/frontend/cloudclient/Components/EventsView';
import DataPaginationRenderer from '@appblocks/frontend/cloudclient/Components/DataPaginationRenderer';
import SyncStatus from '@appblocks/frontend/cloudclient/Components/SyncStatus';
import ModelSelect from '@appblocks/frontend/cloudclient/Components/ModelSelect';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import { Database } from '@appblocks/frontend/client/Components/DeviceDashboard/Database';
import { Settings, DeviceGroupSettingField } from '@appblocks/frontend/client/Components/DeviceDashboard/Settings';
import FirmwareReleasesModal from '@appblocks/frontend/cloudclient/Components/FirmwareReleasesModal';
import ReadMoreComponent from '@appblocks/frontend/client/Components/ReadMoreComponent';
import Tbl from '@appblocks/codegeneration/Libraries/Tbl';
import {
    CMD_TABLE,
    CMD_TABLE_ACTION,
} from '@appblocks/frontend/client/Components/DeviceDashboard/constants';
import SettingsView from '@appblocks/frontend/cloudclient/Components/DeviceGroupSettingsView';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import { format32bitFloat } from '@appblocks/frontend/client/Components/DeviceDashboard/utils';


const store = require('@appblocks/frontend/redux/store').default;

const moment = require('moment');

export default function PageDeviceGroupDetails(props) {
    const [group, setGroup] = useState(undefined);
    const [devices, setDevices] = useState([]);
    const [total, setTotal] = useState(0);
    const [editDevice, setEditDevice] = useState(false);
    const [currentDevice, setCurrentDevice] = useState(undefined);
    const [deviceName, setDeviceName] = useState('');
    const [showFirmwareModal, setShowFirmwareModal] = useState(false);
    const [showAddSetting, setShowAddSetting] = useState(false);
    const [appId, setAppId] = useState(undefined);
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [showDeviceModal, setShowDeviceModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [currentProject, setCurrentProject] = useState(undefined);
    const [projectSettings, setProjectSettings] = useState([]);
    const [currentSetting, setCurrentSetting] = useState(undefined);
    const [currentSettingValue, setCurrentSettingValue] = useState('');
    const [tmpGroupSettings, setTmpGroupSettings] = useState(undefined);
    const [groupSettings, setGroupSettings] = useState([]);
    const [tables, setTables] = useState([]);
    const [projectTables, setProjectTables] = useState([]);
    const [tmpTable, setTmpTable] = useState(undefined);
    const [currentTable, setCurrentTable] = useState('');
    const [showAddTable, setShowAddTable] = useState(false);

    const history = useHistory();
    const dispatch = useDispatch();
    const workspaces = useSelector(state => state.workspaces);

    const getGroup = () => {
        const { groupId } = props.match.params;
        if (groupId) {
            axiosInstance.get(`${process.env.API_URL}/cgg/groups/${groupId}`, {

            })
                .then(async (res) => {
                    setGroup(res.data);
                    setAppId(res.data.project?._id);
                    setCurrentProject(res.data.project);
                    const groupSettings = res.data.settings;
                    setTmpTable(undefined);
                    const settings = [];
                    await PlatformUtils.getDeviceAsync(res.data.projectVersion.device);
                    const project = ProjectConfiguration.fromJson(res.data.projectVersion);
                    const cgg = project.getFeature('cgg');
                    const settingsGroups = cgg.getSettingValue('GROUPS');
                    const settingsHashmap = {};
                    for (let i = 0; i < settingsGroups.length; i++) {
                        const settingsGroup = settingsGroups[i];
                        const settingsGroupSettings = settingsGroup.getSettingValue('SETTINGS');
                        const codeBlocks = settingsGroup.getCodeBlocks();
                        const codeBlock = codeBlocks.filter(block => block.location === 'LUIS_GROUP_ITEM')[0];
                        // eslint-disable-next-line no-eval
                        const settingsConfig = eval?.(`"use strict"; [${codeBlock.template}]`);
                        for (let j = 0; j < settingsConfig.length; j++) {
                            const setting = settingsConfig[j];
                            settings.push(setting);
                            settingsHashmap[setting.variable] = setting;
                        }
                    }
                    const TBL = project.getFeature('tbl');
                    if (TBL) {
                        const tables = TBL.getSettingValue('TABLES').filter(table => table.getSettingValue('STRUCT') === 'T');
                        setProjectTables(tables);
                    }
                    setProjectSettings(settings);
                    for (let i = 0; i < groupSettings.length; i++) {
                        const setting = groupSettings[i];
                        if (settingsHashmap[setting.variable]) {
                            setting.dataType = settingsHashmap[setting.variable].dataType;
                        }
                    }
                    setGroupSettings(groupSettings);
                }).catch((err) => {
                    //
                });
        }
    };

    const getDevices = async ({
        search, start, count, isRefresh,
    }) => {
        setCurrentDevice(undefined);
        const params = {
            search,
            start,
            count,
            group: props.match.params.groupId,
            workspace: workspaces.currentWorkspace,
        };
        if (isRefresh) {
            params.devices = devices.map(device => device.deviceId).join(',');
            params.start = 0;
        }
        const res = await axiosInstance.get(`${process.env.API_URL}/cgg/devices`, {
            params,
        });
        if (!isRefresh) {
            setDevices(res.data.data);
            setTotal(res.data.count);
        } else {
            const updatedDevices = devices.map((device) => {
                const updatedDevice = res.data.data.find(d => d.deviceId === device.deviceId);
                return updatedDevice || device;
            });
            setDevices(updatedDevices);
        }
    };

    useEffect(() => {
        const groupTables = [];
        for (let i = 0; i < projectTables.length; i++) {
            for (let j = 0; j < group.tables.length; j++) {
                const groupTable = group.tables[j];
                if (projectTables[i].getName() === groupTable.name) {
                    const table = projectTables[i];
                    const tableJson = Tbl.getTableJson(table);
                    tableJson.data = groupTable.data.split('\r\n');
                    groupTables.push(tableJson);
                }
            }
        }
        setTables(groupTables);
    }, [projectTables]);

    useEffect(() => {
        getGroup();
    }, []);

    useEffect(() => {
        setCurrentSettingValue('');
    }, [currentSetting]);

    useEffect(() => {
        setCurrentSetting('');
    }, [showAddSetting]);

    useEffect(() => {
        setCurrentTable('');
    }, [showAddTable]);

    const cancelPendingChanges = (key, deviceId) => {
        axiosInstance.delete(`${process.env.API_URL}/cgg/devices/${deviceId}/${key}/changes`, {

        })
            .then((res) => {
                getDevices({
                    search: '',
                    start: 0,
                    count: 10,
                });
            });
    };

    async function removeDevice(device) {
        const { groupId } = props.match.params;
        if (!await confirmDialog(`Remove device "${device.name}" from group?`)) {
            return;
        }
        axiosInstance.delete(`${process.env.API_URL}/cgg/groups/${groupId}/devices/${device.deviceId}`, {

        })
            .then((res) => {
                getDevices({
                    search: '',
                    start: 0,
                    count: 10,
                });
            });
    }

    const onFirmwareSelected = async (version) => {
        if (!await confirmDialog(`Upload firmware "${version.name} - ${version.versionCode}" to ${total} device(s) in group "${group.name}"?`)) {
            return;
        }
        if (!version) {
            return;
        }
        setShowFirmwareModal(false);
        await axiosInstance.post(`${process.env.API_URL}/cgg/groups/${props.match.params.groupId}/firmware`, {
            versionId: version._id,
            workspaceId: workspaces.currentWorkspace,
        });
        dispatch({
            type: 'messages/addMessage',
            payload: {
                title: 'Firmware Upload',
                message: `Firmware "${version.name} - ${version.versionCode}" pushed to ${total} device(s) in group "${group.name}"`,
                delay: 5000,
            },
        });
    };

    const addDevices = async () => {
        const { groupId } = props.match.params;
        const devices = selectedDevices;
        await axiosInstance.post(`${process.env.API_URL}/cgg/groups/${groupId}/devices`, {
            devices,
        });
        getDevices({
            search: '',
            start: 0,
            count: 10,
        });
        setEditDevice(false);
    };

    const addSetting = () => {
        const { groupId } = props.match.params;
        for (let i = 0; i < tmpGroupSettings.length; i++) {
            if (tmpGroupSettings[i].variable === currentSetting) {
                return;
            }
        }
        // find setting from project settings
        for (let i = 0; i < projectSettings.length; i++) {
            if (projectSettings[i].variable === currentSetting) {
                const setting = projectSettings[i];
                setTmpGroupSettings([
                    ...tmpGroupSettings,
                    {
                        ...setting,
                        value: '',
                    },
                ]);
                break;
            }
        }

        setShowAddSetting(false);
    };

    const removeSetting = (variable) => {
        setTmpGroupSettings(tmpGroupSettings.filter(setting => setting.variable !== variable));
    };

    const formChange = (item, e) => {
        if (tmpGroupSettings === undefined) {
            return;
        }
        setTmpGroupSettings(tmpGroupSettings.map((setting) => {
            if (setting.variable === item.variable) {
                return {
                    ...setting,
                    value: e.target.value,
                    invalid: item.invalid,
                };
            }
            return setting;
        }));
    };

    const deleteGroup = async () => {
        if (!await confirmDialog(`Delete group "${group.name}"?`)) {
            return;
        }
        axiosInstance.delete(`${process.env.API_URL}/cgg/groups/${group._id}`)
            .then((res) => {
                history.push('/groups');
            });
    };

    const saveGroupSettings = () => {
        const { groupId } = props.match.params;

        setLoading(true);
        axiosInstance.post(`${process.env.API_URL}/cgg/groups/${groupId}/variables`, {
            variables: tmpGroupSettings.map((setting) => {
                if (setting.dataType === 'INT') {
                    setting.value = Number(format32bitFloat(setting.value, 4));
                }

                return {
                    variable: setting.variable,
                    value: setting.value,
                };
            }),
        })
            .then((res) => {
                dispatch({
                    type: 'messages/addMessage',
                    payload: {
                        title: 'Group Settings',
                        message: 'Group settings updated',
                        delay: 3000,
                    },
                });
                getGroup();
            })
            .finally(() => {
                setLoading(false);
                getDevices({
                    search: '',
                    start: 0,
                    count: 10,
                });
            });
        setTmpGroupSettings(undefined);
    };

    const renderSettingsEditor = () => {
        let settings = tmpGroupSettings;
        if (tmpGroupSettings === undefined) {
            settings = groupSettings;
        }
        return (
            <div>
                {tmpGroupSettings === undefined && (
                    <Button
                        className="mb-3 ms-1 col-md-1"
                        variant="primary"
                        onClick={() => setTmpGroupSettings([...groupSettings])}
                        disabled={!appId}
                        data-testid="btn-edit-device-group-settings"
                    >
                        &nbsp;&nbsp;Edit&nbsp;&nbsp;
                    </Button>
                )}
                {tmpGroupSettings !== undefined && (
                    <div className="row">
                        <div className="col-md-12">
                            <Button
                                className="mb-3 col-md-1 me-1"
                                variant="primary"
                                onClick={() => setShowAddSetting(true)}
                            >
                                Add Setting
                            </Button>
                        </div>
                    </div>
                )}
                {settings.map((setting) => {
                    let projectSetting;
                    for (let i = 0; i < projectSettings.length; i++) {
                        if (projectSettings[i].variable === setting.variable) {
                            projectSetting = projectSettings[i];
                            break;
                        }
                    }
                    if (!projectSetting) {
                        return null;
                    }
                    return (
                        <Form.Group key={setting.variable} className="mt-4">
                            <Form.Label>
                                {projectSetting.name}
                            </Form.Label>
                            <DeviceGroupSettingField
                                setting={projectSetting}
                                onChange={formChange}
                                value={setting.value}
                                disabled={tmpGroupSettings === undefined}
                            />
                            {tmpGroupSettings !== undefined && (
                                <button
                                    type="button"
                                    className="btn btn-link btn-sm"
                                    onClick={() => removeSetting(setting.variable)}
                                >
                                    Remove
                                </button>
                            )}

                        </Form.Group>
                    );
                })}
                {tmpGroupSettings !== undefined && (
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <Button
                                className="mb-3 col-md-1 me-1"
                                variant="primary"
                                onClick={saveGroupSettings}
                                disabled={
                                    loading || tmpGroupSettings.some(setting => setting.invalid)
                                }
                            >
                                Save
                            </Button>
                            <Button
                                className="mb-3 col-md-1"
                                variant="secondary"
                                onClick={() => setTmpGroupSettings(undefined)}
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const runCommand = (type, action, data = {}) => {
        let selectedTable = tmpTable;
        if (tmpTable === undefined) {
            for (let i = 0; i < tables.length; i++) {
                if (tables[i].name === data.table) {
                    selectedTable = tables[i];
                    break;
                }
            }
        }
        return new Promise(async (resolve, reject) => {
            if (type === CMD_TABLE) {
                switch (action) {
                    case CMD_TABLE_ACTION.COUNT:
                        resolve(selectedTable.data.length - 1);
                        break;
                    case CMD_TABLE_ACTION.ROWS: {
                        const header = selectedTable.data[0];
                        let rows = [...selectedTable.data];
                        rows = rows.slice(1);
                        const data = [
                            header,
                            ...rows.map((row, index) => {
                                return `"${index + 1}",${row}`;
                            }),
                        ];
                        resolve(data.join('\r\n'));
                        break;
                    }
                    case CMD_TABLE_ACTION.ADD:
                        if (tmpTable === undefined) {
                            return resolve('');
                        }
                        setTmpTable({
                            ...selectedTable,
                            data: [
                                ...selectedTable.data,
                                data.row,
                            ],

                        });
                        resolve('');
                        break;
                    case CMD_TABLE_ACTION.EDIT:
                        if (tmpTable === undefined) {
                            return resolve('');
                        }
                        for (let j = 0; j < selectedTable.data.length; j++) {
                            if (j.toString() === data.index.toString()) {
                                setTmpTable({
                                    ...selectedTable,
                                    data: selectedTable.data.map((row, index) => {
                                        if (index === j) {
                                            return data.row;
                                        }
                                        return row;
                                    }),
                                });
                                break;
                            }
                        }
                        resolve('');
                        break;
                    case CMD_TABLE_ACTION.DELETE:
                        if (tmpTable === undefined) {
                            return resolve('');
                        }
                        setTmpTable({
                            ...selectedTable,
                            data: selectedTable.data.filter((row, index) => index.toString()
                                !== data.row.toString()),
                        });
                        resolve('');
                        break;
                    case CMD_TABLE_ACTION.CLEAR:
                        if (tmpTable === undefined) {
                            return resolve('');
                        }
                        setTmpTable({
                            ...selectedTable,
                            data: [selectedTable.data[0]], // keep header

                        });
                        resolve('');
                        break;
                    case CMD_TABLE_ACTION.IMPORT:
                        {
                            const dataRows = data.contents.split('\r\n');
                            for (let i = 0; i < dataRows.length; i++) {
                                const row = dataRows[i];
                                if (row.length === 0) {
                                    dataRows.splice(i, 1);
                                    i--;
                                }
                            }
                            setTmpTable({
                                ...selectedTable,
                                count: dataRows.length - 1,
                                data: [
                                    ...dataRows,
                                ],
                            });
                            resolve('');
                        }
                        break;
                    default:
                        resolve({});
                        break;
                }
            }
        });
    };

    const addTable = () => {
        for (let i = 0; i < projectTables.length; i++) {
            if (projectTables[i].getName() === currentTable) {
                const table = projectTables[i];
                const tableJson = Tbl.getTableJson(table);
                const newTable = {
                    ...tableJson,
                    data: [[tableJson.fields.map(field => `"${field.name}"`)].join(',')],
                };
                setTmpTable(newTable);
                setTables([...tables, newTable]);
                break;
            }
        }
        setShowAddTable(false);
    };

    const saveGroupTable = async () => {
        if (!await confirmDialog(`Save table "${tmpTable.name}" to group "${group.name}"?`)) {
            return;
        }
        const { groupId } = props.match.params;
        const tableName = tmpTable.name;
        setLoading(true);
        axiosInstance.post(`${process.env.API_URL}/cgg/groups/${groupId}/tables`, {
            name: tableName,
            action: 'import',
            data: tmpTable.data.join('\r\n'),
        })
            .then((res) => {
                getGroup();
            })
            .finally(() => {
                setLoading(false);
                getDevices({
                    search: '',
                    start: 0,
                    count: 10,
                });
            });
    };

    const removeGroupTable = async () => {
        const { groupId } = props.match.params;
        const tableName = tmpTable.name;
        if (!await confirmDialog(`Remove table "${tableName}" from group "${group.name}"?`)) {
            return;
        }
        setLoading(true);
        axiosInstance.delete(`${process.env.API_URL}/cgg/groups/${groupId}/tables/${tableName}`)
            .then((res) => {
                dispatch({
                    type: 'messages/addMessage',
                    payload: {
                        title: 'Group Table Removed',
                        message: `Table ${tableName} removed from group ${group.name}`,
                        delay: 3000,
                    },
                });
                getGroup();
            })
            .finally(() => {
                setLoading(false);
                getDevices({
                    search: '',
                    start: 0,
                    count: 10,
                });
            });
    };

    const renderTables = () => {
        return (
            <>
                <div className="row">
                    <div className="col-md-12">
                        <Button
                            className="mb-3 col-md-1 me-1"
                            variant="primary"
                            disabled={tmpTable !== undefined}
                            onClick={() => setShowAddTable(true)}
                        >
                            Add Table
                        </Button>
                    </div>
                </div>
                <Tabs
                    className="mt-1"
                >
                    {tables.map((table, index) => {
                        return (
                            <Tab
                                eventKey={index}
                                key={index}
                                title={table.name}
                            >
                                {tmpTable === undefined && (
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Button
                                                className="mb-3 col-md-1 me-1"
                                                variant="primary"
                                                onClick={() => setTmpTable(table)}
                                                data-testid="btn-edit-device-group-database"
                                            >
                                                Edit
                                            </Button>
                                        </div>
                                    </div>
                                )}
                                <Database
                                    tableType="T"
                                    table={(tmpTable && tmpTable.name === table.name)
                                        ? tmpTable
                                        : table}
                                    runCommand={runCommand}
                                    allowEdit={tmpTable !== undefined}
                                />
                                <br />
                                {(tmpTable !== undefined && tmpTable.name === table.name) && (
                                    <>
                                        <Button
                                            className="mb-3 col-md-1 me-1"
                                            variant="primary"
                                            onClick={saveGroupTable}
                                            disabled={loading}
                                        >
                                            Save
                                        </Button>
                                        <Button
                                            className="mb-3 col-md-1 me-1"
                                            variant="secondary"
                                            onClick={() => {
                                                setTmpTable(undefined);
                                                getGroup();
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            className="mb-3 col-md-1"
                                            variant="danger"
                                            onClick={removeGroupTable}
                                        >
                                            Remove
                                        </Button>
                                    </>
                                )}
                            </Tab>
                        );
                    })}
                </Tabs>
            </>
        );
    };

    if (!group) {
        return (
            <Spinner />
        );
    }
    return (
        <>
            <div className="container pt-3">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <NavLink to="/groups">Device Groups</NavLink>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            {group.name}
                        </li>
                    </ol>
                </nav>
                <div className="row mt-2">
                    <div className="col-md-12 p-0">
                        <Button
                            className="mb-3"
                            onClick={() => setEditDevice(true)}
                        >
                            Add Devices
                        </Button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 card pt-3">
                        <div className="row">
                            <div className="col-md-3 mb-3">
                                <small className="text-secondary">
                                    Group Name
                                </small>
                                <div>
                                    {group.name}
                                </div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <small className="text-secondary">
                                    Application (Version)
                                </small>
                                <div>
                                    {group.project ? (
                                        <Link
                                            to={`/app/project/edit/${group.project.id}`}
                                            target="_blank"
                                        >
                                            {group.project.name}
                                            {`(${group.projectVersion ? group.projectVersion.versionCode : 'latest'})`}
                                            <FaExternalLinkAlt className="ms-1" />
                                        </Link>
                                    ) : ''}
                                    &nbsp;
                                </div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <small className="text-secondary">
                                    Devices
                                </small>
                                <div>
                                    {total}
                                </div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <small className="text-secondary">
                                    Synchronization Status
                                </small>
                                <div />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-2 settings-container" style={{ width: 'auto' }}>
                    <Tabs
                        className="mt-1"
                    >
                        <Tab
                            eventKey="1"
                            key={1}
                            title="Member Devices"
                        >
                            <DataPaginationRenderer
                                total={total}
                                getItems={getDevices}
                                showAutoRefresh
                            >

                                <div className="table-responsive table-rounded shadow-sm mb-2">
                                    <Table>
                                        <thead className="table-secondary">
                                            <tr>
                                                <th />
                                                <th>Name</th>
                                                <th>Application</th>
                                                <th>Version</th>
                                                <th>Firmware</th>
                                                <th>Sync</th>
                                                <th>Last Updated</th>
                                                <th />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {devices.length === 0 && (
                                                <tr>
                                                    <td colSpan={10}>
                                                        <div className="table-empty-state-container">
                                                            No Device found.
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                            {devices.map((device) => {
                                                return (
                                                    <tr key={device.deviceId} className="align-middle">
                                                        <td>
                                                            <h5>
                                                                <span className={`badge rounded-pill 
                                                        ${device.state && device.state.connected ? 'text-bg-success' : 'text-bg-secondary'}`}
                                                                >
                                                                    <IoRadioOutline />
                                                                </span>
                                                            </h5>
                                                        </td>
                                                        <td>
                                                            <Link to={`/devices/${device.deviceId}`}>
                                                                {device.name}
                                                            </Link>
                                                        </td>
                                                        <td>
                                                            {device.state.appName}
                                                            {device.state.appId
                                                                !== group.project.id
                                                                && (<FaExclamationTriangle className="ms-1" />)}
                                                        </td>
                                                        <td>
                                                            {device.state.appVersion}
                                                            {(
                                                                !group.projectVersion
                                                                || device.state.appVersion
                                                                !== group.projectVersion.versionCode
                                                            )
                                                                && (<FaExclamationTriangle className="ms-1" />)}
                                                        </td>
                                                        <td>
                                                            {device.state.firmwareVersion}
                                                        </td>
                                                        <td>
                                                            <SyncStatus
                                                                device={device}
                                                                cancel={cancelPendingChanges}
                                                            />
                                                        </td>
                                                        <td>
                                                            {new Date(device.updatedAt)
                                                                .toLocaleString()}
                                                        </td>
                                                        <td>
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="light" className="dropdown-custom float-end">
                                                                    <BsThreeDotsVertical />
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item
                                                                        onClick={() => {
                                                                            removeDevice(device);
                                                                        }}
                                                                    >
                                                                        Remove
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                            </DataPaginationRenderer>
                            <div className="p-5 bg-body-secondary rounded-3">
                                <ReadMoreComponent
                                    initialText={(
                                        /* eslint-disable */
                                        <>
                                            <h5 className="text-body-emphasis">About Member Devices</h5>
                                            <p>
                                                You may add any device to any group, but a device can only be a member of one group. Only the devices running the matching app/version will be active within the group. Devices with a different app/version will be marked as mismatched.
                                            </p>
                                        </>
                                        /* eslint-enable */
                                    )}

                                />
                            </div>
                        </Tab>
                        <Tab
                            eventKey="2"
                            key={2}
                            title="Firmware/App Update"
                        >
                            <Button
                                className="mb-1 ms-1"
                                variant="secondary"
                                onClick={() => setShowFirmwareModal(true)}
                                disabled={!appId}
                                data-testid="btn-device-group-update-firmware"
                            >
                                Select Firmware
                            </Button>
                            <div className="mb-3 ms-1">
                                <small className="text-secondary">
                                    Update Firmware/App for All Devices in the Group
                                </small>
                            </div>

                            <div className="p-5 bg-body-secondary rounded-3">
                                <ReadMoreComponent
                                    initialText={(
                                        /* eslint-disable */
                                        <>
                                            <h5 className="text-body-emphasis">About Firmware/App Updates</h5>
                                            <p>
                                                Device groups support gang-uploading firmware (application) into all member devices (not just matching devices).
                                            </p>
                                            <p>
                                                These updates rely on .TCU (Tibbo Composite Uncompressed) files, which contain both the TiOS (Tibbo OS) and the AppBlocks application code. TCU files are auto-generated by the AppBlocks platform whenever you create a project snapshot.

                                            </p>
                                        </>
                                        /* eslint-enable */
                                    )}
                                    readMoreText={(
                                        /* eslint-disable */
                                        <>
                                            <p>
                                                When you click the Update Firmware/App, the system presents you with a list of available projects, followed by all the snapshots ever created for a particular project.
                                            </p>
                                            <p><i>
                                                Note: The above means that to upload the TCU file for the current project state, you must first create a snapshot of this state.
                                            </i></p>
                                            <div>
                                                Here is how to create snapshots:
                                                <ul>
                                                    <li>Open your project in <b>AppBlocks Designer</b></li>
                                                    <li>Click on the current project version displayed next to the project name</li>
                                                    <li>Select <b>Create Snapshot</b></li>
                                                    <li>Review the suggested version string (see the note below)</li>
                                                    <li>Optionally, add a description and click <b>Create</b></li>
                                                </ul>
                                            </div>
                                            <p><i>
                                                Note: Certain rules apply. For example, you cannot decrease the numbers in the version string, i.e., go from 1.1.10 to 1.1.9.
                                            </i></p>
                                            <div className="row">
                                                <img
                                                    className="img-fluid img-thumbnail col-xl-8 col-lg-8"
                                                    src="/static/img/AppBlocksSnapshots.png"
                                                />
                                            </div>
                                            <p>
                                                <br></br>After updating the firmware of all member devices, you will typically need to change the app/version selection for the group (see the <b>Group Preferences</b>). This is because the updates usually change the app/version of the code running on member devices and thus cause a mismatch between the devices' app/version and the group's app/version.
                                            </p>
                                        </>
                                        /* eslint-enable */
                                    )}
                                />
                            </div>
                        </Tab>
                        <Tab
                            eventKey="3"
                            key={3}
                            title="Delegated Settings"
                        >
                            {renderSettingsEditor()}
                            <br />
                            <div className="p-5 bg-body-secondary rounded-3">
                                <ReadMoreComponent
                                    initialText={(
                                        /* eslint-disable */
                                        <>
                                            <h5 className="text-body-emphasis">About Delegated Settings</h5>
                                            <p>
                                                Device groups facilitate gang management of the member devices' settings. This is achieved through the setting <i>delegation</i>. When you delegate a setting to a group, this group gains the ability to control the value of this setting for all matching devices in the group.
                                            </p>
                                        </>
                                        /* eslint-enable */
                                    )}
                                    readMoreText={(
                                        /* eslint-disable */
                                        <>
                                            <p>
                                                Setting delegation is performed separately for each setting of the group's app/version. Only the settings with read/write access from the cloud can be delegated. Delegated settings cannot be edited on the individual device level.
                                            </p>
                                            {groupSettings.length == 0 && (
                                                <p>
                                                    To get started, click <b>Edit</b>, then <b>Add Setting,</b>, and select a setting to delegate. This setting will be added to the list, and now you will be able to edit it for all matching devices in the group.
                                                </p>
                                            )}
                                            <p>
                                                Do not forget to click <b>Save</b> at the end of your editing!
                                            </p>
                                        </>
                                        /* eslint-enable */
                                    )}
                                />
                            </div>
                        </Tab>
                        <Tab
                            eventKey="4"
                            key={4}
                            title="Delegated Tables"
                        >
                            {renderTables()}

                            <div className="p-5 bg-body-secondary rounded-3">
                                <ReadMoreComponent
                                    initialText={(
                                        /* eslint-disable */
                                        <>
                                            <h5 className="text-body-emphasis">About Device Data Tables</h5>
                                            <p>
                                                Device groups facilitate gang management of the member devices' data tables. This is achieved through the table delegation. When you delegate a table to a group, this group gains the ability to control the contents of this table for all matching devices in the group.
                                            </p>
                                        </>
                                        /* eslint-enable */
                                    )}
                                    readMoreText={(
                                        /* eslint-disable */
                                        <>
                                            <p>
                                                Table delegation is performed separately for each data table of the group's app/version. Only the tables with read/write access from the cloud can be delegated. Delegated tables cannot be edited on the individual device level.
                                            </p>
                                            <p>
                                                To get started, click <b>Add Table</b> and select a data table to delegate. This table will be added to the screen, and now you will be able to edit it for all matching devices in the group.
                                            </p>
                                            <p>
                                                Do not forget to click <b>Save</b> at the end of your editing!
                                            </p>
                                        </>
                                        /* eslint-enable */
                                    )}
                                />
                            </div>
                        </Tab>
                        <Tab
                            eventKey="5"
                            key={5}
                            title="Group Preferences"
                        >
                            <SettingsView
                                group={group}
                                getGroup={getGroup}
                                deleteGroup={deleteGroup}
                            />
                            <div className="p-5 bg-body-secondary rounded-3">
                                <ReadMoreComponent
                                    initialText={(
                                        /* eslint-disable */
                                        <>
                                            <h5 className="text-body-emphasis">About Group Preferences</h5>
                                            <p>
                                                Here, you can change the app/version for this device group. Only the devices running the matching app/version will be active within this group. Devices with a different app/version will be marked as mismatched.
                                                Mismatched devices are ignored for all data-related actions, such as syncing of delegated settings and tables.
                                            </p>
                                        </>
                                        /* eslint-enable */
                                    )}
                                />
                            </div>
                        </Tab>
                    </Tabs>
                </div>
                <FirmwareReleasesModal
                    showFirmwareModal={showFirmwareModal}
                    onClose={() => setShowFirmwareModal(false)}
                    onFirmwareSelect={onFirmwareSelected}
                    appId={appId}
                />
            </div>
            <Modal
                scrollable
                show={editDevice}
                onHide={() => setEditDevice(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Devices</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModelSelect
                        isMulti
                        model="devices"
                        filters={[{
                            field: 'group',
                            operator: '==',
                            value: null,
                        }]}
                        onChange={(selected) => {
                            setSelectedDevices(selected);
                        }}
                        value={selectedDevices}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={addDevices}
                        disabled={selectedDevices.length === 0}
                    >
                        Add Devices
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => setEditDevice(false)}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                scrollable
                show={showAddSetting}
                onHide={() => setShowAddSetting(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Setting to Group</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <small className="text-secondary">
                        Only settings added to the AppBlocks Cloud Console are configurable here.
                    </small>
                    <Form.Group>
                        <Form.Label>Setting</Form.Label>
                        <Form.Control
                            as="select"
                            onChange={(e) => {
                                setCurrentSetting(e.target.value);
                            }}
                        >
                            <option value="">Select Setting</option>
                            {projectSettings.map((setting) => {
                                if (setting.type === 'group') {
                                    return null;
                                }
                                if (
                                    tmpGroupSettings === undefined || tmpGroupSettings.find(
                                        s => s.variable === setting.variable,
                                    ) !== undefined) {
                                    return null;
                                }
                                return (
                                    <option
                                        key={setting.variable}
                                        value={setting.variable}
                                    >
                                        {setting.name}
                                    </option>
                                );
                            })}
                        </Form.Control>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={addSetting}
                    >
                        Add
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => setShowAddSetting(false)}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                scrollable
                show={showAddTable}
                onHide={() => setShowAddTable(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Table to Group</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Table</Form.Label>
                        <Form.Control
                            as="select"
                            onChange={(e) => {
                                setCurrentTable(e.target.value);
                            }}
                        >
                            <option value="">Select Table</option>
                            {projectTables.map((table) => {
                                if (tables.find(t => t.name === table.getName())) {
                                    return null;
                                }

                                return (
                                    <option
                                        key={table.getID()}
                                        value={table.getName()}
                                    >
                                        {table.getName()}
                                    </option>
                                );
                            })}
                        </Form.Control>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={addTable}
                    >
                        Add
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => setShowAddTable(false)}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
